<div class="main-content profile-editor-page ticket-request-page">
  <div class="container-fluid">
    <form [formGroup]='options'>
      <section class="profile-editor-page__hero">
        <div class="ticket-request-page__heading">
          <span class="ticket-request-page__badge" aria-hidden="true"><i class="material-icons">person_search</i></span>
          <div class="profile-editor-page__copy">
            <h1>Solicitud de perfil</h1>
            <p>El perfil que necesitas: puesto, cliente, salario y proyecto.</p>
          </div>
        </div>

        <div class="profile-editor-page__hero-actions">
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)="limpiar()">Limpiar</button>
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)="salir()">Regresar</button>
          <button type="button" class="app-form-btn app-form-btn--primary" (click)="guardaPerfilTicket()"
            [disabled]="!options.valid" onClick="this.disabled=true">Guardar</button>
        </div>
      </section>

      <section class="ticket-request-page__meta" aria-label="Datos de la solicitud">
        <div class="ticket-request-page__meta-item">
          <span>Usuario solicitante</span>
          <strong>{{perfil.ticket.nombreSolicitante}}</strong>
        </div>
        <div class="ticket-request-page__meta-item">
          <span>Área solicitante</span>
          <strong>{{perfil.ticket.areaSolicitante}}</strong>
        </div>
        <div class="ticket-request-page__meta-item">
          <span>Área resolutora</span>
          <strong>{{perfil.ticket.areaResolutora}}</strong>
        </div>
        <div class="ticket-request-page__meta-item">
          <span>Fecha de solicitud</span>
          <strong>{{perfil.ticket.fechaSolicitud | date: 'EEEE, d MMMM, y, h:mm '}}</strong>
        </div>
      </section>

      <div class="row profile-editor-page__layout ticket-request-page__layout">
        <div class="col-xl-5">
          <section class="profile-editor-page__card ticket-request-page__card--grow">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">badge</i>
                <span>Perfil</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="ticket-request-page__grid">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field ticket-request-page__span-all">
                  <mat-label>Perfil solicitado</mat-label>
                  <input matInput aria-label="Perfil solicitado" formControlName='perfilCtrl' [(ngModel)]="perfil.perfil">
                  <mat-error
                    *ngIf=' options.controls.perfilCtrl.invalid && (options.controls.perfilCtrl.dirty || options.controls.perfilCtrl.touched) && options.controls.perfilCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Cantidad de perfiles</mat-label>
                  <input matInput type="number" placeholder="Ingrese un número" aria-label="Cantidad de perfiles"
                    formControlName='numPerfilesCtrl' [(ngModel)]="perfil.numPerfiles">
                  <mat-error
                    *ngIf=' options.controls.numPerfilesCtrl.invalid && (options.controls.numPerfilesCtrl.dirty || options.controls.numPerfilesCtrl.touched) && options.controls.numPerfilesCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Nivel de perfil</mat-label>
                  <mat-select required formControlName='nivelPerfilCtrl' [(ngModel)]="perfil.nivelPerfil">
                    <mat-option *ngFor="let nivel of nivelesEnum" [value]="nivel">{{nivel}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf=' options.controls.nivelPerfilCtrl.invalid && (options.controls.nivelPerfilCtrl.dirty || options.controls.nivelPerfilCtrl.touched) && options.controls.nivelPerfilCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Años de experiencia</mat-label>
                  <input matInput type="number" placeholder="Ingrese un número" aria-label="Años de experiencia"
                    formControlName='experienciaCtrl' [(ngModel)]="perfil.experiencia">
                  <mat-error
                    *ngIf=' options.controls.experienciaCtrl.invalid && (options.controls.experienciaCtrl.dirty || options.controls.experienciaCtrl.touched) && options.controls.experienciaCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>% de inglés</mat-label>
                  <input matInput type="number" aria-label="% de inglés" formControlName="inglesCtrl" [(ngModel)]="perfil.ingles">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                  class="profile-editor-page__field ticket-request-page__span-all">
                  <mat-label>Prioridad</mat-label>
                  <mat-select required formControlName='prioridadCtrl' [(ngModel)]="perfil.ticket.prioridad">
                    <mat-option *ngFor="let items of prioridadesFiltradas" [value]="items.nombre">{{items.nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf=' options.controls.prioridadCtrl.invalid && (options.controls.prioridadCtrl.dirty || options.controls.prioridadCtrl.touched) && options.controls.prioridadCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>
              </div>

              <div class="ticket-request-page__fill">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Conocimientos</mat-label>
                  <textarea required matInput rows="3" aria-label="Conocimientos" formControlName='conocimientoDeseableCtrl'
                    [(ngModel)]="perfil.conocimientoDeseable"></textarea>
                  <mat-error
                    *ngIf=' options.controls.conocimientoDeseableCtrl.invalid && (options.controls.conocimientoDeseableCtrl.dirty || options.controls.conocimientoDeseableCtrl.touched) && options.controls.conocimientoDeseableCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Consideraciones del solicitante</mat-label>
                  <textarea required matInput rows="3" aria-label="Consideraciones del Solicitante"
                    formControlName='consideracionesCtrl' [(ngModel)]="perfil.consideraciones"></textarea>
                  <mat-error
                    *ngIf=' options.controls.consideracionesCtrl.invalid && (options.controls.consideracionesCtrl.dirty || options.controls.consideracionesCtrl.touched) && options.controls.consideracionesCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>
              </div>
            </div>
          </section>
        </div>

        <div class="col-xl-7">
          <section class="profile-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">business</i>
                <span>Cliente</span>
              </div>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact ticket-request-page__header-btn"
                (click)='agregarcliente()'>
                <i class="material-icons" aria-hidden="true">add</i>
                <span>Agregar cliente</span>
              </button>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="ticket-request-page__grid ticket-request-page__grid--3">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Cliente</mat-label>
                  <mat-select required formControlName='idClienteCtrl' [(ngModel)]="perfil.idCliente">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="formCliente" [placeholderLabel]="'Cliente'"
                        [noEntriesFoundLabel]="'No se encontro inforamción'">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let item of filterCliente  | async" [value]="item.id">{{item.razonsocial}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Ubicación</mat-label>
                  <input matInput aria-label="Ubicación" formControlName='ubicacionClienteCtrl' [(ngModel)]="perfil.ubicacionCliente">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Lugar de trabajo</mat-label>
                  <input matInput aria-label="Lugar de trabajo" formControlName="lugartrabajoCtrl" [(ngModel)]="perfil.lugarTrabajo">
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="profile-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">payments</i>
                <span>Salario</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="ticket-request-page__grid ticket-request-page__grid--3">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Tipo de contratación</mat-label>
                  <input matInput aria-label="Tipo de contratación" formControlName='tipoContratacionCtrl'
                    [(ngModel)]="perfil.tipoContratacion">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Horario</mat-label>
                  <input matInput aria-label="Horario" formControlName='horarioCtrl' [(ngModel)]="perfil.horario">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Tarifa</mat-label>
                  <input matInput aria-label="Tarifa" formControlName='tarifaCtrl' [(ngModel)]="perfil.tarifa">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Sueldo a ofertar</mat-label>
                  <input matInput aria-label="Sueldo a ofertar" formControlName='sueldoOfertaCtrl' [(ngModel)]="perfil.sueldoOferta">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Esquema de sueldo</mat-label>
                  <mat-select required formControlName='esquemaSueldoCtrl' [(ngModel)]="perfil.esquemaSueldo">
                    <mat-option *ngFor="let esquema of esquemaEnum" [value]="esquema">{{esquema}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Aprobado por</mat-label>
                  <mat-select required formControlName='aprobadoPorCtrl' [(ngModel)]="perfil.aprobadoPor">
                    <mat-option *ngFor="let nivel of aprobadoPorEnum" [value]="nivel">{{nivel}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="profile-editor-page__card">
            <div class="profile-editor-page__card-header">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">work</i>
                <span>Proyecto</span>
              </div>
            </div>

            <div class="profile-editor-page__card-body">
              <div class="ticket-request-page__grid ticket-request-page__grid--3">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Tipo de proyecto</mat-label>
                  <mat-select required formControlName='tipoProyectoCtrl' [(ngModel)]="perfil.tipoProyecto">
                    <mat-option *ngFor="let proyecto of tipoProyectoEnum" [value]="proyecto">{{proyecto}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Inicio</mat-label>
                  <input matInput [matDatepicker]="fechaIni" aria-label="Inicio" formControlName="fechaInicioCtrl"
                    [(ngModel)]="perfil.fechaInicio">
                  <mat-datepicker-toggle matSuffix [for]="fechaIni"></mat-datepicker-toggle>
                  <mat-datepicker #fechaIni></mat-datepicker>
                  <mat-error
                    *ngIf=' options.controls.fechaInicioCtrl.invalid && (options.controls.fechaInicioCtrl.dirty || options.controls.fechaInicioCtrl.touched) && options.controls.fechaInicioCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field">
                  <mat-label>Fin</mat-label>
                  <input matInput [matDatepicker]="fechaFin" aria-label="Fin" formControlName="fechaFinCtrl"
                    [(ngModel)]="perfil.fechaFin">
                  <mat-datepicker-toggle matSuffix [for]="fechaFin"></mat-datepicker-toggle>
                  <mat-datepicker #fechaFin></mat-datepicker>
                  <mat-error
                    *ngIf=' options.controls.fechaFinCtrl.invalid && (options.controls.fechaFinCtrl.dirty || options.controls.fechaFinCtrl.touched) && options.controls.fechaFinCtrl.errors.required'>
                    El campo es requerido.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="profile-editor-page__field ticket-request-page__span-all">
                  <mat-label>Equipo requerido</mat-label>
                  <input matInput aria-label="Equipo requerido" formControlName='equipoRequeridoCtrl'
                    [(ngModel)]="perfil.equipoRequerido">
                </mat-form-field>
              </div>
            </div>
          </section>
        </div>
      </div>
    </form>
  </div>
</div>
